import { getPhysicalClassDetails } from '@/actions/physical-class';
import { Alert, Button, Calendar, Col, Row, Spin } from 'antd';
import moment, { Moment } from 'moment';
import React, { FC, useEffect, useState } from 'react';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import { ArrowRightOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import useWidth from '@/helpers/widthUtil';
import { IerrorData } from '.';
type Props = {
  classId: number; //id for getting class info
  nextBtn: () => void;
  backBtn: () => void;
  errorData: string;
  setErrorData: (data: IerrorData) => void;
  startTime: string;
  endTime: string;
  handleStartEndTime: (start: string, end: string) => void;
  setCourseDate: (date: string) => void;
  courseDuration: number;
  dateRange: string;
  setDateRange: (dateRange: string) => void;
  courseName: string;
};

const AvailableTime: FC<Props> = ({
  classId,
  nextBtn,
  backBtn,
  errorData,
  setErrorData,
  startTime,
  endTime,
  handleStartEndTime,
  setCourseDate,
  courseDuration,
  setDateRange,
  dateRange,
  courseName,
}) => {
  //For responsive display
  const { isDesktopXL, isLaptop } = useWidth();

  const [value, setValue] = useState<Moment>(moment(new Date()));
  const [selectedValue, setSelectedValue] = useState<Moment>(moment(new Date()));

  const detailData = useSelector(
    (state: RootStateOrAny) => state.physicalClass?.physicalClassDetail
  );

  const { data, loading, error } = detailData;

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getPhysicalClassDetails(classId, value.format('YYYY-MM-DD')));
  }, [classId, value]);

  function addBusinessDays(originalDate, numDaysToAdd) {
    const Saturday = 6;
    let daysRemaining = 1;

    const newDate = originalDate.clone();

    while (daysRemaining < numDaysToAdd) {
      newDate.add(1, 'days');
      if (newDate.day() !== Saturday) {
        daysRemaining++;
      }
    }

    return newDate;
  }

  useEffect(() => {
    if (value) {
      const templastdata = addBusinessDays(value, courseDuration);
      if (templastdata) {
        // setLastDate(templastdata);
        setDateRange(
          `${moment(value).format('YYYY-MM-DD')} to ${moment(templastdata).format(
            'YYYY-MM-DD'
          )}`
        );
      }
    }
  }, [value]);

  const onSelect = (newValue: Moment) => {
    if (newValue > moment().startOf('day')) {
      setErrorData({ courseError: '', dateTimeError: '' });

      const formattedValue = newValue.format('YYYY-MM-DD');

      setValue(moment(newValue));
      setSelectedValue(moment(newValue));
      // setClassInfo(id);
      // dateTimeData(dateData);
      setCourseDate(moment(newValue).format('YYYY-MM-DD'));
    }
  };

  const disabledDate = (current) => {
    return (
      moment(current).day() === 6 || (current && current < moment().startOf('day'))
    );
    // return moment(current).day() === 0;
    // return current && current < moment().startOf('month');
  };

  const dateCellRender = (newValue) => {
    const date = newValue.format('YYYY-MM-DD');
    const eventList = [{ dateRange: dateRange, color: '#283360' }];
    const event = eventList.find((event) => {
      const [start, end] = event.dateRange.split(' to ');
      return moment(date).isBetween(start, end, null, '[]');
    });

    if (event && newValue.day() !== 6) {
      return (
        <div
          style={{
            color: event.color,
            width: '100%',
          }}
          className="d-flex justify-content-end"
        >
          {newValue.date().toString().padStart(2, '0')}
        </div>
      );
    } else if (
      moment(newValue).day() === 6 ||
      (newValue && newValue < moment().startOf('day')) ||
      !newValue.isSame(value, 'month')
    ) {
      return (
        <div
          style={{ color: 'rgba(0, 0, 0, 0.25)', height: '100%', width: '100%' }}
          className="d-flex justify-content-end"
        >
          <div>{newValue.date().toString().padStart(2, '0')}</div>
        </div>
      );
    } else {
      return (
        <div
          style={{ height: '100%', width: '100%' }}
          className="d-flex justify-content-end"
        >
          <div>{newValue.date().toString().padStart(2, '0')}</div>
        </div>
      );
    }
  };
  return (
    <>
      <p className="font-weight-bold mb-4" style={{ fontSize: '20px' }}>
        {courseName}
      </p>
      {errorData && (
        <Alert type="error" showIcon message={errorData} className="mb-3" />
      )}
      {/* {value && (
        <Alert
          type="info"
          showIcon
          message={`Class starts from ${moment(value, 'YYYY-MM-DD').format(
            'YYYY-MM-DD'
          )} to ${moment(value, 'YYYY-MM-DD')
            .add(courseDuration - 1, 'days')
            .format('YYYY-MM-DD')} `}
          className="mb-3"
        />
      )} */}
      {dateRange && (
        <Alert
          type="info"
          showIcon
          message={`Your Class starts from ${dateRange}`}
          className="mb-3"
        />
      )}

      <Row gutter={[20, 20]}>
        <Col
          span={isDesktopXL ? 14 : 24}
          className={`${
            isDesktopXL ? 'border-right' : 'border-bottom'
          } available-calander`}
        >
          <Calendar
            value={moment(selectedValue)}
            disabledDate={disabledDate}
            onSelect={onSelect}
            dateCellRender={dateCellRender}
          />
        </Col>
        <Col span={isDesktopXL ? 10 : 24} className="pl-4">
          <>
            <p className="font-weight-bold p-0 mb-4" style={{ fontSize: '18px' }}>
              Available Time Slots
            </p>
            {value.day() !== 6 ? (
              !loading ? (
                data.data?.length > 0 ? (
                  data?.data?.map(
                    (each, index) =>
                      each?.available_slots > 0 && (
                        <div
                          key={index}
                          className="px-3 py-2 mb-4 rounded cursor-pointer hover-zoom"
                          style={{
                            width: 'fit-content',
                            border: '1px solid #dee2e6',
                            background:
                              startTime == each?.start_time &&
                              endTime == each?.end_time
                                ? '#e6f7ff'
                                : '',
                          }}
                          onClick={() => {
                            handleStartEndTime(each?.start_time, each?.end_time);
                          }}
                        >
                          <div className="d-flex flex-column">
                            <p
                              className="font-weight-bold p-0 m-0"
                              style={{
                                color:
                                  startTime == each?.start_time &&
                                  endTime == each?.end_time
                                    ? '#283360'
                                    : '',
                              }}
                            >{`${moment(each?.start_time, 'HH:mm').format(
                              'hh:mm A'
                            )} - ${moment(each?.end_time, 'HH:mm').format(
                              'hh:mm A'
                            )}`}</p>
                            <p
                              style={{
                                textAlign: 'center',
                                color:
                                  startTime == each?.start_time &&
                                  endTime == each?.end_time
                                    ? '#283360'
                                    : '',
                              }}
                            >
                              {each?.available_slots} Slot left
                            </p>
                          </div>
                        </div>
                      )
                  )
                ) : (
                  <p className="font-weight-bold">No Time Available !</p>
                )
              ) : (
                <div className="d-flex justify-content-center">
                  <Spin />
                </div>
              )
            ) : (
              <p className="font-weight-bold">No Class Available on Saturday !</p>
            )}
          </>
        </Col>
      </Row>
      <div className="my-2 d-flex gap-2 float-right">
        <Button className="float-right" onClick={backBtn}>
          <div className="d-flex gap-2 align-items-center">
            <ArrowLeftOutlined rev="" /> Back
          </div>
        </Button>

        <Button
          type="primary"
          className="float-right"
          onClick={() => {
            nextBtn();
          }}
        >
          <div className="d-flex gap-2 align-items-center">
            Next <ArrowRightOutlined rev="" />
          </div>
        </Button>
      </div>
    </>
  );
};

export default AvailableTime;
